<template>
  <v-container grid-list-md fluid>
    <v-layout row wrap>
      <v-flex md12>
        <data-table ref="table" />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import DataTable from "@/views/reportes/reportevisitas/DataTable"; /** *******************************/

export default {
  name: "ReporteVisitas"
  , components: { DataTable }
  , data() {
    return { view: { title: this.$t("view.reportes.reportevisitas.title") } };
  }
  , head: {
    title: function () {
      return {
        inner: this.view.title
        , separator: "|"
        , complement: this.$t("view.commons.system")
      };
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/reportes/reportevisitas/ReporteVisitas.vue